import { render } from "./AlphaGoat01S4.vue?vue&type=template&id=09e7ed7a"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__